export const EMAILS = { SUPPORT: 'support@arovy.com' };
